<div class="container">
  <mat-card>
    <form [formGroup]="bucketForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-100">
            <mat-label>{{ 'labels.inputs.Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (bucketForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <h3 class="mat-h3 flex-40">{{ 'labels.heading.Delinquency Ranges' | translate }}</h3>

          <div class="flex-40 layout-row align-start-center">
            <button type="button" mat-raised-button color="primary" (click)="addDelinquencyRange()">
              <fa-icon icon="plus" class="m-r-10"></fa-icon>
              {{ 'labels.buttons.Add' | translate }}
            </button>
          </div>

          <table mat-table [dataSource]="rangesDataSource" [hidden]="rangesDataSource.length === 0">
            <ng-container matColumnDef="classification">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Classification' | translate }}</th>
              <td mat-cell *matCellDef="let row">
                {{ row.rangeId | find: delinquencyRangesData : 'id' : 'classification' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="minimumAgeDays">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Days From' | translate }}</th>
              <td mat-cell *matCellDef="let row">
                {{ row.rangeId | find: delinquencyRangesData : 'id' : 'minimumAgeDays' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="maximumAgeDays">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Days Till' | translate }}</th>
              <td mat-cell *matCellDef="let row">
                {{ row.rangeId | find: delinquencyRangesData : 'id' : 'maximumAgeDays' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
              <td mat-cell *matCellDef="let row; let rowIndex = index">
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  (click)="deleteDelinquencyRange(rowIndex)"
                  matTooltip="{{ 'tooltips.Delete' | translate }}"
                  matTooltipPosition="left"
                >
                  <fa-icon icon="trash"></fa-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!bucketForm.valid"
          *LOSxHasPermission="'CREATE_DELINQUENCY_BUCKET'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
